function r(r){throw new Error('Could not dynamically require "'+r+'". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.')}export{r as commonjsRequire};
//# sourceMappingURL=_commonjs-dynamic-modules.js.map
